module.exports = __webpack_public_path__ + "static/media/proj20_img18.d513385b.jpg";